import { useState } from "react";
import "../../styles/studio/visualization/tagInput.css";

const MAX_TAGS = 10;
const MAX_TAG_LENGTH = 20;

const TagInput = ({ tags, setTags, isLoading }) => {
  const [input, setInput] = useState("");

  const addTag = () => {
    const value = input.trim();
    if (
      !value ||
      tags.includes(value) ||
      tags.length >= MAX_TAGS ||
      value.length > MAX_TAG_LENGTH
    )
      return;

    setTags([...tags, value]);
    setInput("");
  };

  const removeTag = (tag) => {
    setTags(tags.filter((t) => t !== tag));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div className="tag-input">
      <label className="tag-label">Tags</label>

      <div className="tag-box">
        {tags.map((tag) => (
          <span key={tag} className="tag-chip">
            #{tag}
            <button
              type="button"
              onClick={() => removeTag(tag)}
              aria-label="Remove tag"
              disabled={isLoading}
            >
              ×
            </button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add tag"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
      </div>

      <div className="tag-meta">
        <span className="hint">Press Enter or comma</span>
        <span className="count">
          {tags.length}/{MAX_TAGS}
        </span>
      </div>
    </div>
  );
};

export default TagInput;
